<template>
    <!--  <div class="contentPage">-->
    <div class="viewAllLoadsWrapper">
        <main-table
            v-if="allLoadsInfo"
            :flag="flag"
            :pageTitle='title'
            :headers="headers"
            :listItems="allLoadsInfo"
            :filtersList="filterLoads"
            :isCreate="false"
            isBackList
            is-export
            @updateExport="onExport"
            @updateBack="onBack"
            @updateSearch="onFilter"
            @updateRefreshFilters="onFilter"
            @updateChangeSort="onFilter"
        ></main-table>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// constants
import { dispatchersStatementsLoadHeader } from "@/constants/defaultHeader";
// import { getActiveSetting } from "@/helper/getActiveSetting";
import { downloadDoc } from "@/helper/getDownloadDoc";
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "view-all-loads",
	props: {
		permissions: Object,
		allLoadsInfo: Array,
		filterLoads: Object,
		id: Number,
		loadsFlag: String,
		loadInfoDate: String,
	},
	computed: {
		...mapGetters([
			'statementsExportLoadsLink',
		]),
		headers() {
			return dispatchersStatementsLoadHeader;
		},
		title() {
			return this.allLoadsInfo[0] ? "Loads of " + this.allLoadsInfo[0].personal_name : "";
		},
	},
	data() {
		return {
			flag: 'viewAllLoads',
			dataArr: [],
		};
	},
	methods: {
		...mapActions([
			'updateFilterLogs',
			'updateLoadInfoFilter',
			'getStatementsLoadsExport',

		]),

		isExport() {
			return this.permissions[PERMISSIONS.ACCOUNT_ST_TS] && this.permissions[PERMISSIONS.EXPORT];
		},
		async onExport(filters) {
			const value = filters;
			value['setting'] = [];
			await this.getStatementsLoadsExport({ value, id: this.id });
		},

		onBack() {
			this.$emit("backFromLoads");
		},
		async onFilter(info) {
			const filter = info.filterModList;
			const id = this.id;
			const date = this.loadInfoDate;
			if (this.loadsFlag === "all") await this.updateFilterLogs({ id, filter });
			if (this.loadsFlag === "one") await this.updateLoadInfoFilter({ id, date, filter });
		},
		backToList() {
			this.$emit("backFromLoads");
		},
	},
	watch: {
		allLoadsInfo(val) {
			this.dataArr = val;
		},
		statementsExportLoadsLink(value, oldValue) {
			if (value !== oldValue) {
				downloadDoc(value);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.viewAllLoadsWrapper {
    height: 100%;
}
</style>
